export const namePattern = /^[A-Za-z\u00C0-\u017F\s-]+$/;
export const passwordUppercasePattern = /(?=.*[A-Z])(?=.*[a-z])/;
export const passwordNumberPattern = /(?=.*\d)/;
export const passwordSpecialCharPattern = /(?=.*\W)/;
export const passwordNoSpacesPattern = /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9\W]).+$/;
export const linkedinPattern = /^(https?:\/\/)?([a-zA-Z]{2,}\.)?linkedin\.com\/in\/[A-Za-z0-9_-]+(?:%[0-9A-Fa-f]{2})*[A-Za-z0-9_-]*\/?$/;
